import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {isServer} from '@salesforce/retail-react-app/app/utils/utils'
import TagManager from '@consteed/frontend/utils/tag-manager'

export const ThirdPartyContext = React.createContext()
export const ThirdPartyProvider = ({children, gtmConfig = {}}) => {
    const {id: gtmId, auth: gtmAuth, preview: gtmPreview, dataLayerName} = gtmConfig

    const initializeTracker = () => {
        if (isServer) return
        TagManager.initialize({
            gtmId: gtmId,
            auth: gtmAuth,
            preview: gtmPreview,
            dataLayerName: dataLayerName,
            dataLayer: {
                // eslint-disable-next-line no-restricted-globals
                originalLocation: `${location.protocol}//${location.hostname}${location.pathname}${location.search}`
            }
        })
    }

    const sendEvents = (...events) => {
        if (isServer) return
        TagManager.sendEvents({dataLayerName, events})
    }

    const eventTracking = (eventName, eventData) => {
        if (isServer) return
        try {
            sendEvents({event: eventName, ...eventData})
        } catch (e) {
            console.error(e.message)
        }
    }

    useEffect(() => {
        initializeTracker()
    }, [])

    return (
        <ThirdPartyContext.Provider
            value={{
                eventTracking,
                sendEvents
            }}
        >
            {children}
        </ThirdPartyContext.Provider>
    )
}

ThirdPartyProvider.propTypes = {
    children: PropTypes.node,
    gtmConfig: PropTypes.object
}
